<template>
  <div class="toaster-inner">
    <div>
      <div class="title">
        {{ title }} <br/>
      </div>
      <div class="info">
        {{ label }}: <span class="link" @click="openTransaction">
        <template v-if="tx">
          {{ tx | getTruncatedString(10, 10) }}
        </template>
        <template v-else>
          {{ id }}
        </template>
      </span>
      </div>
    </div>
  </div>
</template>

<script>
import Copy from "@/public/components/common/copy.vue";
import { mapActions } from "vuex";

export default {
  name: "ToasterInnerComponent",
  components: {
    Copy
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tx: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    fn: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions('app', [
      'openModal'
    ]),
    openTransaction() {
      this.fn({
        name: 'ModalFromWithdrawalToast',
        payload: {
          ...this.$props
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .Vue-Toastification__toast--success {
    background-color: #038C39!important;
  }
  .Vue-Toastification__toast--error {
    background-color: #BE4040!important;
  }
  .toaster-inner {
    font-family: $Gilroy;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .title {
      font-size: $h4;
      font-weight: 500;
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: start;
      flex-wrap: nowrap;
      gap: 8px;

      .link {
        color: var(--new-front-text-primary-bg-purple);
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
</style>